import { supportedLanguages, fallbackLanguage } from "../i18n/language";

export const getValidLangPath = (path: string, i18n: any) => {
  const pathParts = path.split('/');
  const firstSegment = pathParts[1];

  if (supportedLanguages.includes(firstSegment)) return null;

  const detectedLang = i18n.language && supportedLanguages.includes(i18n.language)
    ? i18n.language
    : fallbackLanguage;

  return `/${detectedLang}${path}`;
};
